import { render, staticRenderFns } from "./ChangeInVehicleIDV.vue?vue&type=template&id=12d147e9&scoped=true"
import script from "./ChangeInVehicleIDV.vue?vue&type=script&lang=js"
export * from "./ChangeInVehicleIDV.vue?vue&type=script&lang=js"
import style0 from "./ChangeInVehicleIDV.vue?vue&type=style&index=0&id=12d147e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d147e9",
  null
  
)

export default component.exports